import { TemplateService } from 'src/app/template/template.service';
import { Injectable } from '@angular/core';
import { CameraControl } from 'src/app/digital-twin/graphics/graphics-camera-controler.service';
import { GraphicsLights } from 'src/app/digital-twin/graphics/graphics-lights';
import { GraphicsMaterials } from 'src/app/digital-twin/graphics/graphics-materials';
import { Graphics } from '@app/digital-twin/graphics/graphics';

@Injectable({
  providedIn: 'root'
})
export class DigitalTwinLifecycleManagerService {

  constructor(
    private cameraControl: CameraControl,
    private graphicsLights: GraphicsLights,
    private graphicsMaterials: GraphicsMaterials,
    private graphics: Graphics,
    private TemplateService: TemplateService
  ) { }

  cleanExitArea() {
    this.cameraControl.destroy();
    this.graphics.destroy();

    this.TemplateService.destroy();

    // Cannot call while service is global and its fields are initialized by constructor.
    // Uncomment after refactoring that correctly scopes the services or that initializes the services externally
    //this.graphicsLights.destroy();
    //this.graphicsMaterials.destroy();
  }

  resetAll() {
  }

  destroyAll() {
  }
}
